<template>
	
	<div class="ui vertically padded centered grid container stretch" style="height: 100%">
		<div class="one column row">
            <div class="twelve wide column">
                <h1 class="margin-bottom-0  mt-30">{{news.title}}</h1>
                <p class="grey">{{news.valid_from | date}}</p>
            </div>
        </div>
        <div class="row stretch self-stretch">
            <div class="twelve wide column">
                <div class="body" v-html="news.body"></div>
            </div>
        </div>
        <div class="row">
            <div class="sixteen wide column" v-if="hasGallery">
                <news-gallery class="gallery" :data="news.gallery"></news-gallery>
            </div>
        </div>
        <div class="row">
            <div class="twelve wide column">
                <p>
                    <a :href="backUrl">
                        <button class="ui button">
                            Nazaj na seznam novic
                        </button>
                    </a>
                </p>
            </div>
        </div>
	</div>
</template>

<script>
import slugify from 'slugify'
import queryString from 'query-string'
import NewsGallery from './NewsGallery'

export default {
	components: {
        NewsGallery
    },
    props: ['news'],
	data() {
		return {
		};
	},
	mounted() {
	},
	methods: {
        
	},
    filters: {
        capitalize(text) {
            return text.charAt(0).toUpperCase() + text.slice(1)
        },
        date(value) {
            let date = new Date(Date.parse(value))
            return date.toLocaleDateString('sl-SI')
        }
	},
	computed: {
		backUrl() {
            return this.route('warehouse.news.all')
        },
        hasGallery() {
            return this.news.gallery.length > 0
        }
	}
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/NewsSingle.vue